import { ActionTimestamp } from "../../../action";
import { BrickInventoryEntry } from "../../../BrickInventory/BrickInventory";
import { ActionEntry } from "../../ActionEntries";

export const ApplyCosts = (
  action: ActionEntry,
  newBricks: Map<string, BrickInventoryEntry>,
  _: ActionTimestamp[],
) => {
  // Apply Costs
  //
  // These steps are split so that entire validation is completed prior to application
  // Avoid issue where partial application happens then invalid costs are met
  for (let i = 0; i < action.cost.length; i++) {
    const trueCost =
      action.cost[i].baseChangeValue + action.costIncrement * action.costScale;
    const currBrick = newBricks.get(action.cost[i].brickId)!;

    currBrick.amount -= trueCost;

    if (currBrick.amount < 0) return null;

    // Will leave for now but will revisit in the future potentially
    //
    // const timestamp: ActionTimestamp = {
    //   id: currBrick.id,
    //   amount: trueCost * -1,
    //   timestamp: Date.now(),
    // };

    // newActionTimestamps.push(timestamp);
  }

  return newBricks;
};
